import { useMediaQuery, useTheme } from '@material-ui/core';

export const useBreakpoints = () => {
  const theme = useTheme();
  const isLessThanXs = useMediaQuery(theme.breakpoints.down('xs'));
  const isLessThanSm = useMediaQuery(theme.breakpoints.down('sm'));
  const isLessThanMd = useMediaQuery(theme.breakpoints.down('md'));
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));
  const isMd = useMediaQuery(theme.breakpoints.only('md'));
  const isLg = useMediaQuery(theme.breakpoints.only('lg'));
  const isXl = useMediaQuery(theme.breakpoints.only('xl'));

  return { isLessThanXs, isLessThanSm, isXs, isSm, isMd, isLg, isXl, isLessThanMd };
};

export const useTouchDevice = () => {
  return useMediaQuery('(hover: none)');
};
